import axios from "axios";
import { api } from "~/router/apiConfig";


export function update(contractId, request) {
  return axios.put(
    api.path("contractConfigurationLimit.update", {
      contractId: contractId
    }),
    request
  );
}

export function list(contractId) {
  return axios.get(
    api.path("contractConfigurationLimit.index", { contractId: contractId })
  );
}